import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
    numberAttribute
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'nw-sri-banner',
    templateUrl: './sri-banner.component.html',
    styleUrls: ['./sri-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent]
})
export class SriBannerComponent {
    @Input({ transform: booleanAttribute }) showCurrency: boolean = false;
    @Input({ transform: numberAttribute }) riskLevel!: number;
}
